import {
  FULFILL_SIMPLE_SIGNALS
} from '../constants'
import {ClearState} from '../actions/commonActions'
import {FulfillExpiredSignals, FulfillSignal, FulfillSignals, FulfillSimpleSignals} from '../actions/signalsActions'
import {SimpleSignal} from "../types";


export function simpleSignals(
  state: SimpleSignal[] = [],
  action: FulfillSimpleSignals | ClearState
): SimpleSignal[] {
  switch (action.type) {
    case FULFILL_SIMPLE_SIGNALS:
      return action.signals
    default:
      return state
  }
}
